import { Box, Flex, Strong, Text } from "@radix-ui/themes";
import { ChatAvatar } from "./ChatAvatar";
import moment from "moment/moment";
import { IMessage } from "../../modals/ActivityModal/ActivityModal";
import { MessageAttachment } from "./MessageAttachment";
import { useState } from "react";
import translateStyles from "../../schoolfeed/ContentPostDisplay/styles/TranslateButton.module.scss";
import styles from "./styles/Message.module.scss";

export function Message(props: { message: IMessage }) {
  const hasSavedTranslation = !!props.message.translated;

  const [content, setContent] = useState(
    props.message.translated || props.message.content,
  );

  // True when the user is looking at the saved translation rather than the original
  const isShowingSavedTranslation =
    hasSavedTranslation &&
    content === props.message.translated &&
    content !== props.message.content;

  return (
    <Flex gap={"3"} py={"4"}>
      <Box>
        <ChatAvatar branding={props.message.branding} />
      </Box>
      <Box>
        <Strong>{props.message.title}</Strong>{" "}
        <Text size={"1"}>
          {moment(props.message.created_at).format("MMM D • h:mm a")}
        </Text>
        {props.message.attachments.length > 0 &&
          props.message.attachments.map((attachment) => (
            <MessageAttachment key={attachment.url} attachment={attachment} />
          ))}
        <Text
          // notranslate prevents GT from retranslating content that is already
          // in the user's language. When showing the original for GT to work
          // from, we leave this off so GT can do its job.
          className={`${styles.content}${isShowingSavedTranslation ? " notranslate" : ""}`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {hasSavedTranslation && (
          <Box>
            {isShowingSavedTranslation ? (
              <button
                className={translateStyles.translateButton}
                onClick={() => setContent(props.message.content)}
              >
                See in original language
              </button>
            ) : (
              <button
                className={translateStyles.translateButton}
                onClick={() => setContent(props.message.translated as string)}
              >
                See translated
              </button>
            )}
          </Box>
        )}
      </Box>
    </Flex>
  );
}
